<template>
    <div class="m-cnt">
        <div>
            <div v-if="picture" class="homeback">
                <div class="pic">
                    <img src="../../assets/home.png" alt="" style="width:100%;height:100%;opacity:1">
                </div>
                <div class="rule" @click="playRule">活动规则</div>
                <div class="result">
                    <div>今日积分：<span style="padding-right: 15px;">{{this.results.score}}</span>
                        今日排名：<span>{{this.sorty>15?'未上榜':this.sorty}}</span></div>
                </div>
                <div class="background container">
                    <div class="bowl-container">
                        <div class="sprite bowl inline" id="bowl">
                            <div class="sprite dice dice-position1"></div>
                            <div class="sprite dice dice-position2"></div>
                            <div class="sprite dice dice-position7"></div>
                            <div class="sprite dice dice-position4"></div>
                            <div class="sprite dice dice-position5"></div>
                            <div class="sprite dice dice-position6"></div>
                        </div>
                    </div>
                    <div class="button-container">
                        <div>你还有 {{times}} 次博饼机会</div>
                        <div id="startGame" @click="playGame">开始博饼</div>
                        <div @click="toShare">分享好友</div>
                    </div>
                </div>
                <div class="rate">
                    <div class="ratenum">
                        <img src="../../assets/rate.png" alt=""
                            style="width:100%;height:100%;opacity: 1;background:none !important;">
                    </div>
                    <div class="content">
                        <div class="box" v-for="item in this.list" :key="item.id">
                            <!-- <div style="font-style:oblique;">{{item.rank}}</div>
                            <div style="width: 68%;text-align: left;padding-left: 15px;">
                                <span>{{item.userName}}</span>
                            </div>
                            <div style="width:36%;">
                                <span style="text-align: left;">积分: {{item.score}}</span>
                            </div> -->
                            <div class="rank">{{item.rank}}</div>
                            <div class="name">{{item.userName}}</div>
                            <div class="score">积分: {{item.score}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 活动规则 -->
            <div v-else class="paly">
                <div @click="back">返回</div>
                <div>
                    <img src="../../assets/rule.png" alt="" style="width:100%;height:100%;opacity: 1;">
                </div>
            </div>
            <div class="mask-layer share-mask" v-show="isSharePop">
                <div class="share-pop">
                    <div class="share-img">
                        <img src="http://img.huashitong.net/mkt/bargain-share.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Common from "@/api/common.js"
    import Mkt from "@/api/mkt.js";
    import { Toast } from 'mint-ui';
    import $ from 'jquery'
    import Cookies from 'js-cookie';
    import Device from "@/utils/device.js";

    export default {
        name: 'Bobing',
        data() {
            return {
                picture: true,
                results: {
                    // list: [],
                    // res:'',
                    score: '0', //积分
                    result: "", //结果
                    points: [], //骰子点数
                    award: "" //头衔奖励
                },
                total: 3,
                isAPP: false,
                isMINI: false,
                sorty: '未上榜',
                list: [],
                times: '0',
                isSharePop: false
            }
        },
        mounted() {
            // if (!Cookies.get("token")) {
            //     return
            // }
            Mkt.getCore().then(res => {
                this.list = res.results
            })
            Mkt.getSorty().then(res => {
                this.results.score = res.results.score
                this.times = res.results.times
                this.sorty = res.results.rank;
            })
            // 微信客户端的情况下
            // if (Device.isWX()) {
            //     // console.log(1111)
            //     this.getCopywriting();
            // }
        },
        methods: {
            playRule() {
                this.picture = false
            },
            back() {
                this.picture = true
            },
            // 分享好友
            toShare() {
                if (!Cookies.get("token")) {
                    this.$loginModal()
                    return
                }
                this.isSharePop = true
                setTimeout(function () {
                    this.shareSuccess()
                }.bind(this), 3000)
            },
            shareSuccess() {
                Mkt.getAddTime().then(res => {
                    console.log(res)
                    if (res.code == 200) {
                        Mkt.getSorty().then(res => {
                            this.results.score = res.results.score
                            this.times = res.results.times
                            this.sorty = res.results.rank;
                        })
                    }
                })
                window.location.reload();
            },
            // 开始博饼
            playGame() {
                // 判断token
                if (!Cookies.get("token")) {
                    if (this.isAPP) {
                        // Toast("请先登录~")
                    } else if (this.isMINI) {
                        let redirect_uri = encodeURIComponent(`/pages/webview/webview?url=${window.location.href}`)
                        wx.miniProgram.navigateTo({
                            url: `/pages/user/login/login?redirect_uri=${redirect_uri}`
                        })
                        return
                    } else {
                        this.$loginModal()
                        return
                    }
                }
                if (this.times <= 0) {
                    Toast({
                        message: '今日次数已用完，分享好友可增加次数哦',
                        position: 'center',
                        duration: 2000
                    });
                    this.times = 0
                } else {
                    // this.total --;
                    const game = new Game();
                    const midAutumn = new MidAutumn()
                    game.start();
                    // console.log('game', game)
                    // console.log('game', game.result)
                    // console.log('midAutumn111', game.midAutumn.getAward().name)

                    this.results.points = game.result.toString()
                    this.results.result = game.midAutumn.getAward().name

                    switch (this.results.result) {
                        case '未中奖':
                            this.results.award = '未中奖'
                            break;
                        case '一秀':
                            this.results.award = '秀才'
                            break;
                        case '二举':
                            this.results.award = '举人'
                            break;
                        case '四进':
                            this.results.award = '进士'
                        case '三红':
                            this.results.award = '探花'
                            break;
                        case '对堂':
                            this.results.award = '榜眼'
                        case '四点红' || '五子登科' || '五王' || '六杯黑' || '六杯红':
                            this.results.award = '状元'
                            break;
                        default:
                            this.award = '状元插金花'
                    }
                    // console.log('this.award', this.results.award)
                    // this.total == 0
                    Mkt.getGame(this.results).then(res => {
                        // console.log('res1111111', res)
                        //点击开始博饼的时候请求一次博饼活动-获取用户当前积分
                        Mkt.getSorty().then(res => {
                            // console.log('res555555555', res)
                            this.results.score = res.results.score
                            this.times = res.results.times
                            this.sorty = res.results.rank;
                        })
                        Mkt.getCore().then(res => {
                            // console.log('res77777777777', res)
                            this.list = res.results
                            // console.log('this.list99999999', this.list)
                        })
                        setTimeout(() => {
                            Toast({
                                message: this.results.result=='未中奖' ? this.results.result : '恭喜你博到了' + this.results.result,
                                position: 'center',
                                duration: 1000
                            });
                        }, 500)
                    })
                }
            },
            // 分享
            getCopywriting() {
                // 随机一条文案
                let shareDesc = '我正在参加时事一点通中秋博饼游戏，一起来试试手气',
                    shareTitle = '时事一点通，博饼赢彩头';
                var _url = window.location.href;
                Common.getWXConfig(_url).then(res => {
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: res.results.appId, // 必填，公众号的唯一标识
                        timestamp: res.results.timestamp, // 必填，生成签名的时间戳
                        nonceStr: res.results.nonceStr, // 必填，生成签名的随机串
                        signature: res.results.signature, // 必填，签名，见附录1
                        jsApiList: [
                            "onMenuShareTimeline",
                            "onMenuShareAppMessage",
                            "updateAppMessageShareData",
                            "updateTimelineShareData"
                        ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                    });
                    wx.ready(function () {
                        let shareData = {
                            title: shareTitle,
                            desc: shareDesc, //这里请特别注意是要去除html
                            link: _url,
                            imgUrl: "http://img.huashitong.net/ssydt/share-logo.png"
                        };

                        if (wx.onMenuShareAppMessage) {
                            //微信文档中提到这两个接口即将弃用，故判断
                            wx.onMenuShareAppMessage({
                                ...shareData,
                                success: function () {
                                    // console.log(123);
                                    // that.shareSuccess()
                                }
                            }); //1.0 分享到朋友
                            wx.onMenuShareTimeline(shareData); //1.0分享到朋友圈
                        } else {
                            wx.updateAppMessageShareData(shareData); //1.4 分享到朋友
                            wx.updateTimelineShareData(shareData); //1.4分享到朋友圈
                        }
                    });
                });
            }
        }
    }

    class Game {
        result = [];
        position = [];
        midAutumn = new MidAutumn();

        start() {
            this.result = this.midAutumn.start();
            // this.result = this.midAutumn.setResult([4, 4, 4, 4, 1, 1]).getResult();
            // console.log('this.result', this.result)
            // console.log('this.midAutumn.getAward()', this.midAutumn.getAward());
            this.setDice();
        }
        getPosition() {
            let position = []
            this.position = [1, 2, 3, 4, 5, 6, 7];
            for (let i = 0; i < 6; i++) {
                position.push(this.position.splice(Math.floor(Math.random() * this.position.length), 1)[0])
            }
            return position;
        }
        setDice() {
            $("#bowl").removeClass('active');
            const position = this.getPosition();
            $.each($("#bowl .dice"), (index, item) => {
                $(item).removeClass();
                $(item).addClass(`sprite dice dice${this.result[index]} dice-position${position[index]}`)
            })
            setTimeout(() => {
                $("#bowl").addClass('active');
            }, 200)
        }
    }

    class MidAutumn {
        constructor(config = {}) {
            this.config = config;
        }
        result = [];
        awardList = [];

        // '000600' 六勃红
        // '600000' 遍地锦
        // '060000' '006000' '000060' '000006' 六勃黑
        // '111111' 对堂
        // '100500' '010500' '001500' '000510' '000501' 五红
        // '5xxxxx' 'x5xxxx' 'xx5xxx' 'xxxx5x' 'xxxxx5' 五子登科
        // '200400' 状元插金花
        // 'xxx4xx' 状元
        // '4xxxxx' 'x4xxxx' 'xx4xxx' 'xxxx4x' 'xxxxx4' 四进
        // 'xxx3xx' 三红
        // 'xxx2xx' 二举
        // 'xxx1xx' 一秀
        rule = [{
            reg: /000600/,
            name: '六杯红'
        }, {
            reg: /6/,
            name: '六杯黑'
        }, {
            reg: /111111/,
            name: '对堂'
        }, {
            reg: /^\d{3}5\d{2}$/,
            name: '五王'
        }, {
            reg: /5/,
            name: '五子登科'
        }, {
            reg: /200400/,
            name: '状元插金花'
        }, {
            reg: /^\d{3}4\d{2}$/,
            name: '四点红'
        }, {
            reg: /4/,
            name: '四进'
        }, {
            reg: /^\d{3}3\d{2}$/,
            name: '三红'
        }, {
            reg: /^\d{3}2\d{2}$/,
            name: '二举'
        }, {
            reg: /\d{3}1\d{2}$/,
            name: '一秀'
        }]

        _change() {
            const {
                onChange
            } = this.config;
            typeof onChange === 'function' && onChange(this.result);
        }

        // 开始博饼
        start() {
            return this.getPoint();
        }
        // 获取随机的6个点数
        getPoint() {
            this.result.length = 0;
            for (let i = 0; i < 6; i++) {
                this.result.push(Math.floor(Math.random() * 6) + 1)
            }
            this._change();
            return this.result;
        }
        // 通过传入特定的6个色子设置结果的点数
        setResult(result) {
            if (!(result instanceof Array) || result.length !== 6) {
                throw new Error('设置的结果必须是一个数字数组，并且每个数字在1到6之间');
            }
            this.result = result;
            this._change();
            return this;
        }
        getResult() {
            return this.result;
        }
        // 统计结果，将不同的点数统计在对应的位置上
        // [1点, 2点, 3点, 4点, 5点, 6点]
        _countResult() {
            this.award = [0, 0, 0, 0, 0, 0];
            this.result.forEach(item => {
                this.award[item - 1]++;
            });
            return this;
        }
        // 判断结果是什么奖项
        getAward() {
            this._countResult();
            const awardString = this.award.join('');
            // console.log('awardString', awardString);
            if (this.rule && this.rule.length) {
                for (let i = 0; i < this.rule.length; i++) {
                    if (this.rule[i].reg.test(awardString)) {
                        return {
                            name: this.rule[i].name,
                        }
                    }
                }
                return {
                    name: '未中奖',
                }
            }
        }
    }
</script>

<style lang="less">
    .homeback {
        position: relative;

        .pic {
            position: absolute;
        }
    }

    .rule {
        width: 43px;
        text-align: center;
        background: #E54C3F;
        border-radius: 20px 0px 0px 20px;
        position: fixed;
        font-size: 26px;
        right: 0;
        top: 236px;
        font-weight: 400;
        color: white;
        padding: 5px 0;
    }

    .result {
        font-size: 30px;
        position: absolute;
        left: 15%;
        top: 410px;
        width: 70%;
        height: 60px;
        line-height: 60px;
        border-radius: 10px;
        margin: 0 auto;
        background: #FFD1B5;
        color: #E54C3F;
        text-align: center;
    }


    .rate {
        position: absolute;
        margin: 0 auto;
        top: 1200px;
        width: 90%;

        .ratenum {
            width: 307px;
            height: 73px;
            margin-left: 33%;
        }

        .content {
            margin-left: 10%;
            margin-top: 30px;
            border: 1px solid #DBB081;
            color: #C3352B;
            font-weight: bold;
            background: #FFF3E7;
            height: 260px;
            font-size: 30px;
            border-radius: 20px;
            height: 16vh;
            overflow: hidden;
            overflow-y: scroll;

            .box:nth-child(1) {
                padding-top: 15px;
            }

            .box {
                display: flex;
                padding: 0 30px 15px;
            }

            .rank {
                font-style: oblique;
                width: 72px;
            }

            .name {
                margin-right: 30px;
                width: 300px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .score {
                flex-shrink: 0;
                width: calc(100% - 372px);
                white-space: nowrap;
            }
        }
    }

    .paly {
        position: relative;
    }

    .paly>div {
        position: absolute;
    }

    .paly>div:nth-child(1) {
        z-index: 999;
        top: 30px;
        left: 40px;
        font-size: 32px;
        color: #C3352B;
        font-weight: 600;
    }

    @keyframes diceAnimation {
        0% {
            transform: translate3d(0, -100px, 0) rotate(0);
        }

        40% {
            transform: translate3d(0, 0, 0) rotate(180deg);
        }

        60% {
            transform: translate3d(20px, -50px, 0) rotate(50deg);
        }

        80% {
            transform: translate3d(30px, 0px, 0) rotate(-40deg);
        }

        90% {
            transform: translate3d(-13px, -15px, 0) rotate(180deg);
        }

        100% {
            transform: translate3d(0, 0px, 0) rotate(0deg);
        }
    }

    @keyframes diceAnimation2 {
        0% {
            transform: translate3d(0, -100px, 0) rotate(0);
        }

        40% {
            transform: translate3d(0, 0, 0) rotate(170deg);
        }

        60% {
            transform: translate3d(-30px, -45px, 0) rotate(0deg);
        }

        80% {
            transform: translate3d(30px, 0px, 0) rotate(-80deg);
        }

        90% {
            transform: translate3d(-20px, -10px, 0) rotate(150deg);
        }

        100% {
            transform: translate3d(0, 0px, 0) rotate(0deg);
        }
    }

    @keyframes diceAnimation3 {
        0% {
            transform: translate3d(0, -100px, 0) rotate(0);
        }

        40% {
            transform: translate3d(0, 0, 0) rotate(140deg);
        }

        60% {
            transform: translate3d(-30px, -40px, 0) rotate(30deg);
        }

        80% {
            transform: translate3d(-20px, 0px, 0) rotate(-60deg);
        }

        90% {
            transform: translate3d(10px, -20px, 0) rotate(170deg);
        }

        100% {
            transform: translate3d(0, 0px, 0) rotate(0deg);
        }
    }


    .hCenter() {
        position: absolute;
        left: 50%;
        transform: translate3d(-50%, 0, 0)
    }

    .position(@top, @left) {
        top: @top;
        left: @left;
    }

    .inline {
        display: inline-block;
    }

    // .background {
    //     height: 100%;
    //     background: url(../image/bg2.jpg) no-repeat;
    //     background-size: cover;
    // }

    .sprite {
        background: url(../../assets/sprite.png) no-repeat;
        background-size: 1000px 1000px;
    }

    .container {
        width: 70%;
        position: absolute;
        left: 15%;
        padding-top: 7.3rem;
        overflow: hidden;

        .bowl-container {
            text-align: center;
            margin-top: 30px;

            .bowl {
                transform: scale(2);
                width: 260px;
                height: 215px;
                position: relative;
                background-position: -10px -10px;

                .dice {
                    display: none;
                    width: 35px;
                    height: 35px;
                    position: absolute;

                    &.dice1 {
                        background-position: -280px -10px;
                    }

                    &.dice2 {
                        background-position: -325px -10px;
                    }

                    &.dice3 {
                        background-position: -370px -10px;
                    }

                    &.dice4 {
                        background-position: -415px -10px;
                    }

                    &.dice5 {
                        background-position: -460px -10px;
                    }

                    &.dice6 {
                        background-position: -505px -10px;
                    }

                    &.dice-position1 {
                        .position(90px, 80px);
                    }

                    &.dice-position2 {
                        .position(72px, 118px);
                    }

                    &.dice-position3 {
                        .position(88px, 160px);
                    }

                    &.dice-position4 {
                        .position(122px, 160px);
                    }

                    &.dice-position5 {
                        .position(142px, 118px);
                    }

                    &.dice-position6 {
                        .position(122px, 80px);
                    }

                    &.dice-position7 {
                        .position(108px, 118px);
                    }
                }

                &.active {
                    .dice {
                        display: block;

                        &.dice-position1 {
                            animation: diceAnimation 1s cubic-bezier(0.39, 0.12, 0.85, 0.48);
                        }

                        &.dice-position2 {
                            animation: diceAnimation2 800ms cubic-bezier(0.39, 0.12, 0.85, 0.48);
                        }

                        &.dice-position3 {
                            animation: diceAnimation3 600ms cubic-bezier(0.39, 0.12, 0.85, 0.48);
                        }

                        &.dice-position4 {
                            animation: diceAnimation 750ms cubic-bezier(0.39, 0.12, 0.85, 0.48);
                        }

                        &.dice-position5 {
                            animation: diceAnimation2 500ms cubic-bezier(0.39, 0.12, 0.85, 0.48);
                        }

                        &.dice-position6 {
                            animation: diceAnimation3 678ms cubic-bezier(0.39, 0.12, 0.85, 0.48);
                        }

                        &.dice-position7 {
                            animation: diceAnimation3 800ms cubic-bezier(0.39, 0.12, 0.85, 0.48);
                        }
                    }
                }
            }
        }

        .button-container {
            // position:absolute;
            margin-top: 100px;
            text-align: center;

            div:nth-child(1) {
                font-size: 30px;
                text-align: center;
                color: #C3352B;
                margin-bottom: 30px;
            }

            div:nth-child(2) {
                width: 90%;
                background: #C3352B;
                font-weight: 600;
                margin: 0 auto;
                color: white;
                height: 80px;
                font-size: 35px;
                line-height: 80px;
                border-radius: 15px;
                border-radius: 50px;
            }

            div:nth-child(3) {
                width: 90%;
                margin: 0 auto;
                color: #C3352B;
                height: 80px;
                font-size: 35px;
                line-height: 80px;
                border: 1px solid #C3352B;
                border-radius: 50px;
                margin-top: 20px;
            }
        }
    }
</style>